import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories } from '@/mocks/articles';

function getCategoryName(slug: string): string {
  const cat = categories.find((c) => c.slug === slug);
  return cat?.name || slug;
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = articles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen pt-20 flex items-center justify-center bg-background-50">
          <div className="text-center">
            <div className="w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <i className="ri-folder-unknow-line text-foreground-400 text-5xl"></i>
            </div>
            <h1 className="text-2xl font-bold text-foreground-950 mb-2">分类未找到</h1>
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      <section className="w-full pt-20 pb-10 bg-gradient-to-b from-primary-900/30 to-background-50">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center py-16">
          <h1 className="text-4xl md:text-6xl font-black text-foreground-950 font-heading mb-4">
            {category.name}专区
          </h1>
          <p className="text-foreground-600 text-base mb-8 max-w-lg mx-auto">
            {category.description}
          </p>
          <Link
            to={`/category/${slug}`}
            className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览最新
            <i className="ri-arrow-right-line"></i>
          </Link>
          <div className="mt-10 flex flex-wrap justify-center gap-3">
            {['直播', '带货', '翻车', '内幕', '曝光', '追踪', '热议', '独家'].map((tag) => (
              <span
                key={tag}
                className="bg-background-200/60 text-foreground-600 text-xs px-3 py-1.5 rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 py-14">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="text-3xl font-bold text-foreground-950 font-heading">
                {category.name}
              </h2>
              <p className="text-foreground-600 text-sm mt-2">
                共 {categoryArticles.length} 篇爆料
              </p>
            </div>
          </div>
          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  category={article.category}
                  categoryName={getCategoryName(article.category)}
                  publishDate={article.publishDate}
                  imageUrl={article.imageUrl}
                  isHot={article.isHot}
                  isExclusive={article.isExclusive}
                  viewCount={article.viewCount}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <i className="ri-inbox-line text-foreground-400 text-4xl"></i>
              </div>
              <p className="text-foreground-600">该分类下暂无内容</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
}